import { render } from "./ReadMore.vue?vue&type=template&id=4bdab788&scoped=true"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"

import "./ReadMore.vue?vue&type=style&index=0&id=4bdab788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdab788"]])

export default __exports__